// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__BhKGG","tooltip_icon":"Tooltip_tooltip_icon__gAYiq","tooltip_active":"Tooltip_tooltip_active__sXi1c","tooltip_hidden":"Tooltip_tooltip_hidden__8EwFK"};